import type {
  BankingBankAccount,
  BankingBankInfo,
  BankingPartner,
  BankingPersonalInformation,
  BankingUser,
  UserEligibility,
} from '@wizbii/utils/models';

import { createReducer, on } from '@ngrx/store';
import {
  CheckUserEligibility,
  CreateBankingUserIfEligibleSuccess,
  InitBankingStateSuccess,
  UpdateBankingBankAccount,
  UpdateBankingBankInfos,
  UpdateBankingPartner,
  UpdateBankingPersonalInformation,
  UpdateBankingUser,
} from '@stores/banking/banking-ngrx.action';

export const bankingKey = 'banking';

export interface BankingStateModel {
  user?: BankingUser | null;
  hasFetchBankingUser?: boolean | null;
  bankAccount?: BankingBankAccount | null;
  bankInfos?: BankingBankInfo | null;
  personalInformation?: BankingPersonalInformation | null;
  bankingPartner?: BankingPartner | null;
  eligibility?: UserEligibility | null;
}

export const initialState: BankingStateModel = {
  user: undefined,
  hasFetchBankingUser: undefined,
  bankAccount: undefined,
  bankInfos: undefined,
  personalInformation: undefined,
  bankingPartner: undefined,
};

export const bankingReducer = createReducer(
  initialState,
  on(InitBankingStateSuccess, (_, state) => {
    return state;
  }),
  on(UpdateBankingUser, (state, { user }) => {
    return { ...state, user };
  }),
  on(UpdateBankingBankAccount, (state, { bankAccount }) => {
    return { ...state, bankAccount };
  }),
  on(UpdateBankingBankInfos, (state, { bankInfos }) => {
    return { ...state, bankInfos };
  }),
  on(UpdateBankingPersonalInformation, (state, { personalInformation }) => {
    return { ...state, personalInformation };
  }),
  on(UpdateBankingPartner, (state, { bankingPartner }) => {
    return { ...state, bankingPartner };
  }),
  on(CreateBankingUserIfEligibleSuccess, (state, { user }) => {
    return user ? { ...state, user } : state;
  }),
  on(CheckUserEligibility, (state, { eligibility }) => {
    return { ...state, eligibility };
  })
);
